module.exports = __webpack_public_path__ + "img/team-spirit-rafiki.b2db6720.svg";